import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
const vNodeCache = {};
let KeepAliveGlobal = class KeepAliveGlobal extends Vue {
    constructor() {
        super(...arguments);
        this.name = 'keep-alive';
        this.abstract = true;
    }
    render() {
        const slot = this.$slots.default;
        if (!slot) {
            console.log('slot is undefined');
            return slot;
        }
        const vnode = slot[0];
        const key = vnode.key;
        if (!key) {
            return vnode || (slot && slot[0]);
        }
        if (vNodeCache[key]) {
            vnode.componentInstance = vNodeCache[key].componentInstance;
        }
        else {
            vNodeCache[key] = vnode;
        }
        if (vnode.data) {
            vnode.data.keepAlive = true;
        }
        return vnode || (slot && slot[0]);
    }
};
KeepAliveGlobal = tslib_1.__decorate([
    Component
], KeepAliveGlobal);
export default KeepAliveGlobal;
//# sourceMappingURL=KeepAliveGlobal.js.map